import request from '@/utils/request'

// 获取当前生效协议
export const getAgreementCurrent = (formData) => {
    return request.get(`/agreement/current`, {params: formData});
};

// 创建协议新版本
export const addAgreement = (formData) => {
    return request.post(`/agreement`, formData);
};
